// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"bY-z","subtitle":"cY-z","wrapper":"dY-z","leftArrow":"eY-z","rightArrow":"fY-z"};